import { FLOWS, useUploadFlow } from "hook/bailiff/document/flow/useUploadFlow";
import FinishLoading from "./component/finish_loading";
import FinishCompleted from "./component/finish_completed";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const UploadFinish = () => {
  // -------------------------- VAR -----------------------------
  const { flow } = useUploadFlow();
  const isFlow = flow === FLOWS.SUCCESS;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!isFlow) return null;
  return (
    <>
      <FinishLoading />
      <FinishCompleted />
    </>
  );
};
export default UploadFinish;
